(function () {
  var root = document.getElementById('yhl-mobile-menu');
  if (!root) return;
  // Header ancestors are transformed, which would contain position:fixed — hoist to body.
  if (root.parentElement !== document.body) document.body.appendChild(root);
  var dialog = root.querySelector('.yhl-mm__dialog');
  var rootPanel = root.querySelector('[data-panel="root"]');
  var rootScroll = rootPanel.querySelector('.yhl-mm__scroll');
  var openers = document.querySelectorAll('[data-mm-open]');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  ['touchend', 'pointerup', 'mouseup'].forEach(function (ev) {
    root.addEventListener(ev, function (e) { if (isOpen() && e.target.closest('[data-mm-panel],[data-mm-back],[data-mm-close],[data-mm-accordion],.yhl-mm__scrim')) e.stopPropagation(); }, true);
  });
  var trigger = null, current = null, opener = null, rootTop = 0, pushed = false;

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null; }
    );
  }
  function setExpanded(v) {
    Array.prototype.forEach.call(openers, function (b) { b.setAttribute('aria-expanded', v); });
  }
  function isOpen() { return root.classList.contains('is-open'); }

  function open(t) {
    if (isOpen()) return;
    trigger = t;
    root.classList.add('is-open');
    document.documentElement.classList.add('yhl-mm-lock');
    setExpanded('true');
    window.setTimeout(function () { dialog.focus({ preventScroll: true }); }, reduce ? 0 : 60);
  }
  function close(keepFocus) {
    if (!isOpen()) return;
    if (current) back(false);
    root.classList.remove('is-open');
    document.documentElement.classList.remove('yhl-mm-lock');
    setExpanded('false');
    if (trigger && !keepFocus) trigger.focus({ preventScroll: true }); // CB-248: the sticky header can open the menu mid-page
    document.dispatchEvent(new CustomEvent('yhl:menu-closed'));
  }
  // Login opens the Axentra popup in place and stops click propagation; window-capture runs first.
  window.addEventListener('click', function (e) {
    if (isOpen() && e.target.closest && e.target.closest('.yhl-mm__login')) window.setTimeout(function () { close(true); }, 150);
  }, true);
  function showPanel(key, t) {
    var p = root.querySelector('[data-panel="' + key + '"]');
    if (!p || current === p) return;
    rootTop = rootScroll.scrollTop;
    opener = t;
    current = p;
    p.hidden = false;
    void p.offsetWidth;
    dialog.classList.add('is-sub');
    p.classList.add('is-active');
    p.querySelector('.yhl-mm__scroll').scrollTop = 0;
    if (!pushed) { gkNeutralise(); history.pushState({ yhlMenu: key }, ''); pushed = true; }
    p.querySelector('.yhl-mm__title').focus({ preventScroll: true });
  }
  /* The checkout SDK pushes {sideCart:true} when its cart opens and never pops it on close, and its popstate
     handler re-opens the cart whenever the browser lands on that entry. Rewrite the current entry before we push
     ours, so our history.back() returns to a neutral entry instead of re-opening the cart. */
  function gkNeutralise() {
    try {
      var st = history.state;
      if (st && st.sideCart) history.replaceState(Object.assign({}, st, { sideCart: false }), '', location.href);
    } catch (e) {}
  }
  window.yhlGkNeutralise = gkNeutralise;
  function back(viaHistory) {
    var p = current;
    if (!p) return;
    current = null;
    dialog.classList.remove('is-sub');
    p.classList.remove('is-active');
    window.setTimeout(function () { if (current !== p) p.hidden = true; }, reduce ? 0 : 220);
    rootScroll.scrollTop = rootTop;
    if (opener) opener.focus();
    if (pushed && !viaHistory) { pushed = false; history.back(); }
  }

  Array.prototype.forEach.call(openers, function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); open(b); });
  });

  // Capture phase + stopPropagation: page-level delegates (theme, jQuery, cart apps) must never act on taps
  // that the drawer handles itself. Plain links (products, pills, help, login, cart) still bubble normally.
  /* accordion body: slide open / closed (height + fade), then hand back to [hidden] */
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function slideBox(box, open) {
    if (reduceMotion) { box.hidden = !open; return; }
    /* height is border-box, so the grid's bottom padding is animated with it; otherwise the box stops 14px short and jumps */
    var done = false;
    var finish = function () {
      if (done) return; done = true;
      box.removeEventListener('transitionend', onEnd);
      if (!open) box.hidden = true;
      box.style.height = ''; box.style.opacity = ''; box.style.paddingBottom = ''; box.style.transition = '';
    };
    var onEnd = function (ev) { if (ev.target === box && ev.propertyName === 'height') finish(); };
    if (open) {
      /* measure at full size, then jump to the collapsed start WITHOUT transitioning (reading scrollHeight
         flushes a style with height:auto, so a plain height:0 afterwards would animate 193 -> 0 first and the
         open would dip before growing) */
      box.style.transition = 'none';
      box.hidden = false;
      box.style.height = ''; box.style.paddingBottom = '';
      var h = box.scrollHeight;                       /* full height incl. padding */
      box.style.height = '0px'; box.style.paddingBottom = '0px'; box.style.opacity = '0';
      box.getBoundingClientRect();
      box.style.transition = '';
      box.addEventListener('transitionend', onEnd);
      requestAnimationFrame(function () { requestAnimationFrame(function () {
        box.style.height = h + 'px'; box.style.paddingBottom = ''; box.style.opacity = '1';
      }); });
    } else {
      box.style.height = box.offsetHeight + 'px'; box.style.opacity = '1';
      box.getBoundingClientRect();
      box.addEventListener('transitionend', onEnd);
      box.style.height = '0px'; box.style.paddingBottom = '0px'; box.style.opacity = '0';
    }
    setTimeout(finish, 420);                          /* safety net if transitionend never fires */
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mm-panel],[data-mm-back],[data-mm-close],[data-mm-accordion]');
    if (!t) return;
    e.stopPropagation();
    if (t.hasAttribute('data-mm-panel')) { e.preventDefault(); showPanel(t.getAttribute('data-mm-panel'), t); }
    else if (t.hasAttribute('data-mm-back')) { e.preventDefault(); back(false); }
    else if (t.hasAttribute('data-mm-close')) { e.preventDefault(); close(); }
    else {
      var box = document.getElementById(t.getAttribute('aria-controls'));
      var exp = t.getAttribute('aria-expanded') === 'true';
      t.setAttribute('aria-expanded', exp ? 'false' : 'true');
      if (box) slideBox(box, !exp);
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var panel = current || rootPanel;
    var f = focusables(panel);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || !panel.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !panel.contains(a))) { e.preventDefault(); first.focus(); }
  });

  window.addEventListener('popstate', function () {
    if (pushed && current) { pushed = false; back(true); }
  });
})();
